'use client';
import { Link } from 'react-scroll';
import { motion } from 'motion/react';
import SplashCursor from '@/components/animations/SplashCursor';
import styles from './styles.module.css';

export default function StartBanner() {
  return (
    <section className={styles.hero}>
      <SplashCursor
        SIM_RESOLUTION={128}
        DYE_RESOLUTION={1440}
        DENSITY_DISSIPATION={0.3}
        VELOCITY_DISSIPATION={0.1}
        PRESSURE={0.1}
        CURL={3}
        SPLAT_RADIUS={1}
        SPLAT_FORCE={2200}
        COLOR_UPDATE_SPEED={15}
      />

      <div className={styles.inner}>
        <div className={styles.content}>
          <motion.h1
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1, ease: 'easeInOut' }}
            className={styles.title}
          >
            Разрабатываем{" "}
            <span className={styles.titleAccent}>смелые цифровые продукты</span>
            {" "}с вниманием к деталям
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1, delay: 0.1, ease: 'easeInOut' }}
            className={styles.subtitle}
          >
            Берём на себя продукт, дизайн и разработку, чтобы вы могли фокусироваться
            на бизнесе, а не на технической реализации.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1, delay: 0.2, ease: 'easeInOut' }}
            className={styles.actions}
          >
            <Link
              to="contacts"
              spy={true}
              smooth={true}
              offset={-180}
              duration={500}
              className={styles.primaryButton}
            >
              Обсудить проект
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
